export default "__VITE_ASSET__ClcQZYUj__"